// ThemeBadge.tsx
type ThemeBadgeProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'purple';
  icon?: React.ReactNode;
  className?: string;
};

const badgeVariants = {
  primary: 'bg-blue-600 text-white',
  success: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  warning: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400',
  danger: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
  info: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400',
  purple: 'bg-purple-600 text-white'
};

export const ThemeBadge: React.FC<ThemeBadgeProps> = ({ 
  children, 
  variant = 'primary', 
  icon,
  className = ''
}) => {
  return (
    <div className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs uppercase tracking-wide ${badgeVariants[variant]} ${className}`}>
      {icon && <span className="text-xs">{icon}</span>}
      {children}
    </div>
  );
};